export default "__VITE_PUBLIC_ASSET__da11a9eb__"